import common_axios from "./commonAxios";

let baseURL = common_axios.defaults.baseURL;

export const fetchDataUploadHistory = (startDateNew, endDateNew, pageNumber, perPage, sortColumn, sortDirection) => {
    const params = { "startDate": startDateNew, "endDate": endDateNew, 'pageNumber': pageNumber, 'perPage': perPage, 'sortColumn': sortColumn, 'sortDirection': sortDirection }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_data_upload_history', params);
    return dataPass;
};

export const fetchProcessedDataInsights = (id) => {
    const params = { "id": id }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_processed_data_insights', params);
    return dataPass;
};

export const fetchProcessedDataInsightsGraphs = (id) => {
    const params = { "id": id }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_processed_data_insights_graphs', params);
    return dataPass;
};

export const downloadFile = (fileUrl) => {
    const params = { "fileUrl": fileUrl }
    var dataPass = common_axios.post(baseURL + 'hih/download_file', params);
    return dataPass;
};

export const fetchReports = (pageNumber, perPage, sortColumn, sortDirection) => {
    const params = { 'pageNumber': pageNumber, 'perPage': perPage, 'sortColumn': sortColumn, 'sortDirection': sortDirection }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_reports', params);
    return dataPass;
};

export const generateReport = (startDate, endDate, downloadEvent, extraParams) => {
    let params = { 'startDate': startDate, 'endDate': endDate, 'downloadEvent': downloadEvent, 'extraParams': extraParams }
    let response = common_axios.post('hih/generate_reports', params);
    return response;
}

export const getFileLink = (id) => {
    let params = { 'reportId': id }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_fileurl', params);
    return dataPass;
};

export const fetchServiceRecommendationHistory = (startDate, endDate, searchStr, pageNumber, perPage, sortColumn, sortDirection) => {
    const params = { 'startDate': startDate, 'endDate': endDate, 'searchStr': searchStr, 'pageNumber': pageNumber, 'perPage': perPage, 'sortColumn': sortColumn, 'sortDirection': sortDirection }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_service_recommendation_history', params)
    return dataPass;
}

export const addServiceRecommendationsFile = (file, fileName, source) => {
    const params = { 'file': file, 'fileName': fileName, 'source': source }
    var dataPass = common_axios.post(baseURL + 'hih/upload_health_service_recommendations_file', params)
    return dataPass;
};

export const fetchRefillPoolData = (selectedCurrentStatus, startDate, endDate, pageNumber, perPage, sortColumn, sortDirection) => {
    const params = { 'selectedCurrentStatus': selectedCurrentStatus, 'startDate': startDate, 'endDate': endDate, 'pageNumber': pageNumber, 'perPage': perPage, 'sortColumn': sortColumn, 'sortDirection': sortDirection }
    console.log(params);
    var dataPass = common_axios.post(baseURL + 'hih/fetch_refill_pool_data', params)
    return dataPass;
};

export const fetchMemberPersonalData = (userId, cancelToken) => {
    const params = { 'userId': userId }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_member_personal_data', params, cancelToken)
    return dataPass;
};

export const checkMembership = (membershipNo, cancelToken) => {
    const params = { 'membershipNo': membershipNo }
    var dataPass = common_axios.post(baseURL + 'hih/check_member_details', params, cancelToken)
    return dataPass;
};

export const saveNewMember = (formData, memberType, currentStatus, source, cancelToken) => {
    const params = { 'formData': formData, 'memberType': memberType, 'currentStatus': currentStatus, 'source': source }
    var dataPass = common_axios.post(baseURL + 'hih/save_new_member', params, cancelToken)
    return dataPass;
};

export const fetchAIServiceRecommendations = (membershipNumber, cancelToken) => {
    const params = { 'membershipNumber': membershipNumber }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_ai_service_recommendations', params, cancelToken)
    return dataPass;
};

export const dismissAIServiceRecommendations = (recommendationIDs, dismissalReason, dismissalComments, dismissalServiceType, userId, cancelToken) => {
    const params = { 'recommendationIDs': recommendationIDs, 'dismissalReason': dismissalReason, 'dismissalComments': dismissalComments, 'dismissalServiceType': dismissalServiceType, 'userId': userId }
    var dataPass = common_axios.post(baseURL + 'hih/dismiss_ai_service_recommendations', params, cancelToken)
    return dataPass;
};

export const fetchDropdownList = (settingKeyword, cancelToken) => {
    const params = { 'settingKeyword': settingKeyword }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_dropdown_list', params, cancelToken)
    return dataPass;
};

export const saveMedication = (formData, cancelToken) => {
    const params = { 'formData': formData }
    var dataPass = common_axios.post(baseURL + 'hih/save_medication_data', params, cancelToken)
    return dataPass;
};

export const saveMedicationMetaDoc = (formData, cancelToken) => {
    const params = { 'formData': formData }
    var dataPass = common_axios.post(baseURL + 'hih/save_medication_data_metadoc', params, cancelToken)
    return dataPass;
};

export const fetchFormDataMedication = (cityId, membership, cancelToken) => {
    const params = { 'cityId': cityId, 'membership': membership }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_medication_form', params, cancelToken)
    return dataPass;
};

export const fetch_admin_user_data = () => {
    var dataPass = common_axios.get(baseURL + 'hih/fetch_admin_user_data');
    return dataPass;
};

export const fetch_role_data = () => {
    var dataPass = common_axios.get(baseURL + 'hih/fetch_role_data');
    return dataPass;
};

export const hih_user_creation_data = (formData) => {
    const params = { 'formData': formData }
    var dataPass = common_axios.post(baseURL + 'hih/hih_user_creation_data', params);
    return dataPass;
};

export const fetch_ad_users_list = (searchString) => {
    var requestBody = { searchString };
    var dataPass = common_axios.post(baseURL + 'hih/fetch_ad_users', requestBody);
    return dataPass;
};

export const hih_fetch_admin_user_data = (userId) => {
    const params = { 'userId': userId }
    var dataPass = common_axios.post(baseURL + 'hih/hih_fetch_admin_user_data', params);
    return dataPass;
};


export const hih_admin_user_update_data = (userId, formData) => {
    const params = { 'userId': userId, 'formData': formData }
    var dataPass = common_axios.post(baseURL + 'hih/hih_admin_user_update_data', params);
    return dataPass;
};

export const fetch_supervisors_list = () => {
    var dataPass = common_axios.post(baseURL + 'hih/fetch_supervisors_list');
    return dataPass;
};

export const fetchUserEdgeData = (userId, requestFrom, cancelToken) => {
    const params = { 'userId': userId, 'requestFrom': requestFrom }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_user_edge_data', params, cancelToken)
    return dataPass;
};

export const searchMedicationDrugsMetaDoc = (searchStr, searchType, cancelToken) => {
    const params = { 'searchStr': searchStr, 'searchType': searchType }
    var dataPass = common_axios.post(baseURL + 'hih/search_medication_drugs_metadoc', params, cancelToken)
    return dataPass;
};

export const fetchFormData = (cityId, membership, cancelToken) => {
    const params = { 'cityId': cityId, 'membership': membership }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_form_data', params, cancelToken)
    return dataPass;
};

export const saveLabRequest = (formData, cancelToken) => {
    const params = { 'formData': formData }
    var dataPass = common_axios.post(baseURL + 'hih/save_lab_request', params, cancelToken)
    return dataPass;
};

export const saveLabRequestMetaDoc = (formData, cancelToken) => {
    const params = { 'formData': formData }
    var dataPass = common_axios.post(baseURL + 'hih/save_lab_request_metadoc', params, cancelToken)
    return dataPass;
};

export const fetchPoolDataList = (poolFilterType, pageNumber, perPage, sortColumn, sortDirection) => {
    const params = { 'poolFilterType': poolFilterType, 'pageNumber': pageNumber, 'perPage': perPage, 'sortColumn': sortColumn, 'sortDirection': sortDirection }
    console.log(params);
    var dataPass = common_axios.post(baseURL + 'hih/fetch_pool_data_list', params)
    return dataPass;
};

export const createNewPool = (poolMemberType, poolDataSource, poolContractNumber, poolServiceType) => {
    const params = { 'poolMemberType': poolMemberType, 'poolDataSource': poolDataSource, 'poolContractNumber': poolContractNumber, 'poolServiceType': poolServiceType }
    console.log(params);
    var dataPass = common_axios.post(baseURL + 'hih/create_new_pool', params)
    return dataPass;
};

export const fetchPoolPerformance = (startDate, endDate, filterCriteria, pageNumber, perPage, sortColumn, sortDirection) => {
    const params = { 'startDate': startDate, 'endDate': endDate, 'filterCriteria': filterCriteria, 'pageNumber': pageNumber, 'perPage': perPage, 'sortColumn': sortColumn, 'sortDirection': sortDirection }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_pool_performance', params)
    return dataPass;
}


export const fetchRefillPartnerList = () => {
    const params = {}
    var dataPass = common_axios.post(baseURL + 'hih/fetch_refill_partner_list', params)
    return dataPass;
}

export const homeServiceTracker = (status, page, perPage, sortColumn, sortDirection, download, userTimeZone, serviceType, formData) => {
    const params = { status, page, perPage, sortColumn, sortDirection, download, userTimeZone, serviceType, formData }
    var dataPass = common_axios.post(baseURL + 'hih/home_service_insight', params)
    return dataPass;
}

export const add_data_source = (formData) => {
    var dataPass = common_axios.post(baseURL + 'hih/add_data_source', formData);
    return dataPass;
};

export const fetch_data_source_list = (searchStr, pageNumber, perPage, sortColumn, sortDirection) => {
    const params = { 'searchStr': searchStr, 'pageNumber': pageNumber, 'perPage': perPage, 'sortColumn': sortColumn, 'sortDirection': sortDirection }
    return common_axios.post(baseURL + 'hih/fetch_data_source_list', params);
}


export const fetch_data_source_info = (id) => {
    let params = { 'recordId': id };
    var dataPass = common_axios.post(baseURL + 'hih/fetch_data_source_info', params);
    return dataPass;
};


export const edit_data_source = (formData) => {
    var dataPass = common_axios.post(baseURL + 'hih/edit_data_source', formData);
    return dataPass;
};

export const remove_data_source = (id) => {
    let params = { 'recordId': id };
    var dataPass = common_axios.post(baseURL + 'hih/remove_data_source', params);
    return dataPass;
};

export const fetchAIBUPADataSource = (systemGenerated, cancelToken) => {
    const params = { 'systemGenerated': systemGenerated }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_data_sources', params, cancelToken)
    return dataPass;
};

export const fetchPoolSettingsList = () => {
    const params = {}
    var dataPass = common_axios.post(baseURL + 'hih/fetch_pool_settings_list', params)
    return dataPass;
};

export const updatePoolSettings = (formData, cancelToken) => {
    const params = { 'formData': formData }
    var dataPass = common_axios.post(baseURL + 'hih/update_pool_settings', params, cancelToken)
    return dataPass;
};

export const fetchRefillPoolInsights = () => {
    const params = {}
    var dataPass = common_axios.post(baseURL + 'hih/fetch_refill_pool_insights', params)
    return dataPass;
}
export const refreshPreauth = (serviceId, serviceType) => {
    const params = { 'serviceId': serviceId, 'serviceType': serviceType }
    var dataPass = common_axios.post(baseURL + 'hih/refresh_preauth', params)
    return dataPass;
};
export const fetchMetadocProductList = () => {
    var dataPass = common_axios.get(baseURL + 'hih/fetch_metadoc_product_list');
    return dataPass;
};

export const fetchAIBUPARecordsForMapping = (searchStr, pageNumber, perPage, sortColumn, sortDirection) => {
    const params = { 'searchStr': searchStr, 'pageNumber': pageNumber, 'perPage': perPage, 'sortColumn': sortColumn, 'sortDirection': sortDirection }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_ai_bupa_records_for_mapping', params);
    return dataPass;
};

export const addAIBUPAMapping = (formData, cancelToken) => {
    const params = { 'formData': formData }
    var dataPass = common_axios.post(baseURL + 'hih/add_ai_bupa_mapping', params, cancelToken)
    return dataPass;
};

export const updateAIBUPAMapping = (formData, cancelToken) => {
    const params = { 'formData': formData }
    var dataPass = common_axios.post(baseURL + 'hih/update_ai_bupa_mapping', params, cancelToken)
    return dataPass;
};

export const searchAIBUPAMapping = (searchStr, cancelToken) => {
    const params = { 'searchStr': searchStr }
    var dataPass = common_axios.post(baseURL + 'hih/search_ai_bupa_mapping', params, cancelToken)
    return dataPass;
};
export const fetchPoolContracts = (searchStr) => {
    const params = { 'searchStr': searchStr }
    var dataPass = common_axios.post(baseURL + 'hih/fetch_pool_contracts', params);
    return dataPass;
};
